import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component ProjectStarIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <ProjectStarIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <ProjectStarIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const ProjectStarIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      data-testid="ProjectStarIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={ref}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        fillRule="evenodd"
        d="M4 15v5h5v-5zm0-2h5a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2m11-9v5h5V4zm0-2h5a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2m0 13v5h5v-5zm0-2h5a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2"
        clipRule="evenodd"
      />
      <path d="M6.505 9.631 4.198 10.9a.43.43 0 0 1-.592-.193.48.48 0 0 1-.044-.29l.44-2.687-1.865-1.903a.474.474 0 0 1-.008-.649.43.43 0 0 1 .251-.133l2.578-.392 1.153-2.445a.43.43 0 0 1 .787 0L8.05 4.653l2.578.392c.24.036.406.269.371.52a.47.47 0 0 1-.128.262L9.006 7.73l.44 2.686a.456.456 0 0 1-.357.53.42.42 0 0 1-.278-.046z" />
    </svg>
  )
);
ProjectStarIcon.displayName = "ProjectStarIcon";
export default ProjectStarIcon;
